import WalletChooseType from "./WalletChooseType";

export default WalletChooseType;
